import Form from "react-bootstrap/Form";

export default function InputWithLabel({
  inputId,
  label = null,
  placeholder = "",
  type = "text",
  // Pass over the react-hook-form register function!
  register = () => {},
  // Wraper styling, default to margin bottom 3 (mb-3)
  wrapperClass = "mb-3",
  disabled = false,
  inputProps = null,
  error = null,
  errorMessage = "Required field.",
  validation = {},
}) {
  if (!inputId) {
    console.error(`ERR: Missing input ID! InputWithLabel`);
    return <></>;
  }

  if (!type) {
    console.error(`ERR: Missing input Type! InputWithLabel`);
  }

  return (
    <div className={wrapperClass}>
      {label !== null ? (
        <label htmlFor={inputId} className="form-label">
          {label}
          <span className="text-danger">{validation?.required ? "*" : null}</span>
        </label>
      ) : null}

      <Form.Control
        type={type}
        {...register(inputId, { ...validation })}
        className={`form-control ${error ? "error" : ""}`}
        placeholder={placeholder}
        {...inputProps}
        as={type === "textarea" ? type : undefined}
        disabled={disabled}
      />

      {error ? <label className="error">{errorMessage}</label> : null}
    </div>
  );
}
